module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/pre-2",
      "id": "nav-prev"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/luxy",
      "id": "nav-next"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "_content"
    }
  }, [_c('div', [_c('video', {
    staticClass: "video-webcam",
    attrs: {
      "id": "_webcam0"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_imageData0"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_faceSub0"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_threejs0"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_drawing0"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba523e78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Showcase.vue
// module id = 32
// module chunks = 0